module.exports = __webpack_public_path__ + "img/surveyYes.f6d77645.svg";